import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 50,
      },
      smartphone: {
        padding: 20,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    mobile: {
      desktop: {
        fontSize: "28pt",
        // padding: 20,
      },
      smartphone: {
        fontSize: "22pt",
        // padding: 10,
      },
    },
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: 10,
  },
  FORM_FIELD: {
    style: {
      maxWidth: "100%",
    },
    inputStyle: {
      width: "100%",
      padding: 20,
      border: "1px solid #DDD",
      borderRadius: 4,
    },
    labelStyle: {
      fontFamily: "Roboto",
      fontSize: "10pt",
      textAlign: "left",
      padding: 5,
    },
  },
  BUTTON: {
    style: {
      display: "inline-block",
      padding: 12,
      border: "none",
      backgroundColor: theme.backgroundColor,
      width: "100%",
      borderRadius: 3,
      cursor: "pointer",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "14pt",
    },
    caption2: {
      color: theme.foregroundColor,
      fontSize: "9pt",
    },
  },
};
